import Authentication from '@/assets/auth.png';
import { HelpMenu } from '@/shared/components/help-menu';
import { Logo } from '@/shared/components/logo';

import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <main className="bg-white dark:bg-gray-900">
      <div className="relative md:flex">
        {/* Content */}
        <div className="md:w-1/2">
          <div className="min-h-dvh h-full flex flex-col after:flex-1">
            {/* Header */}
            <div className="flex-1">
              <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
                <Logo />
                <HelpMenu />
              </div>
            </div>

            <Outlet />
          </div>
        </div>

        {/* Image */}
        <div className="hidden md:block absolute top-0 bottom-0 right-0 md:w-1/2" aria-hidden="true">
          <img
            className="object-cover object-center w-full h-full"
            src={Authentication}
            width="760"
            height="1024"
            alt="Authentication"
          />
        </div>
      </div>
    </main>
  );
}
